import { FeatureMapItem } from '~app/pages/Pricing/transformers/types';

const Grow2529FeatureMap: FeatureMapItem[] = [
  {
    featureItemKey: 'grow_2529_create_limit',
    features: ['survey_create_limit', 'create_question_limit'],
  },
  {
    featureItemKey: 'grow_2529_question_types',
  },
  {
    featureItemKey: 'grow_2529_unlimited_questions',
  },
  {
    featureItemKey: 'grow_2529_analysis_filter',
  },
  {
    featureItemKey: 'grow_2529_file_upload',
  },
  {
    featureItemKey: 'grow_2529_payment_qt',
  },
  {
    featureItemKey: 'grow_2529_website_embed',
  },
  {
    featureItemKey: 'grow_2529_zapier_integrations',
  },
  {
    featureItemKey: 'everything_in',
  },
  {
    featureItemKey: 'grow_2529_analyze_export_spss_enabled',
  },
  {
    featureItemKey: 'grow_2529_unlimited_analysis_filters',
  },
  {
    featureItemKey: 'grow_2529_survey_quiz',
  },
];

export default Grow2529FeatureMap;
